import {ModuleFc} from '@/project'
import {InvitationState} from './types'
import {cloneDeep} from 'lodash'
import {updateObject} from '@/store/utils'

export {InvitationState}

const initState: InvitationState = {
  invitationId: null,
  bizId: null,
  bizName: null,
  creatorName: null,
  phoneNumber: null,
}

const module: ModuleFc<InvitationState> = (ctx) => ({
  namespaced: true,
  state: cloneDeep(initState),
  actions: {
    /**
     * Get information of Invitation
     * @param commit
     * @param rootState
     * @param invitationId
     */
    async getInvitation({commit}, {invitationId}) {
      const result = await ctx.$axios({
        url: '/invitations/$id',
        method: 'get',
        params: {invitationId},
      })
      commit('update', {...result.data, invitationId})
    },
    /**
     * Post(Send) certificate number to user phone number
     * @param state
     * @param invitationId
     */
    async sendAuthSms({state}, {invitationId = ''} = {}) {
      const result = await ctx.$axios({
        url: '/invitations/$id/send-auth-sms',
        method: 'post',
        params: {invitationId: invitationId || state.invitationId},
      })
      return result.data
    },
    /**
     * Post certNumber
     * @param state
     * @param invitationId
     * @param certNumber
     */
    async checkAuthSms({state}, {invitationId = '', certNumber = ''} = {}) {
      const result = await ctx.$axios({
        url: '/invitations/$id/check-auth-sms',
        method: 'post',
        params: {invitationId: invitationId || state.invitationId},
        data: {certNumber},
      })
      return result.data
    },
    /**
     * Post sign up to invitation
     * @param state
     * @param commit
     * @param invitationId
     */
    async signUpToInvitation({state, commit}, {invitationId = ''} = {}) {
      const result = await ctx.$axios({
        url: '/invitations/$id',
        method: 'post',
        params: {invitationId: invitationId || state.invitationId},
      })
      commit('update', {bizId: result?.data?.bizId})
      return result.data
    },
  },
  mutations: {
    /**
     * Update invitation state
     * @param state
     * @param payload
     */
    update(state, payload: InvitationState) {
      updateObject(state, payload)
    }
  }
})

export default module
